import React from 'react';
import { FieldArray, Field, FormSection } from 'redux-form';
import { SelectField } from 'redux-form-material-ui';
import { MenuItem, FlatButton, IconButton } from 'material-ui';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import AddIcon from 'material-ui/svg-icons/content/add';
import { CAMPAIGN_FORM_KEYS as FORM_KEYS } from '../../../constants';
import { presence } from 'dash-front/helpers/validation';
import { yCenter } from '../helpers';

const onTargetAdd = fields => () =>
    fields.push({ [FORM_KEYS.TARGETS.TYPE]: 'smlink' });

const onRemoveTarget = (fields, index) => () => {
    if (fields.length > 1) {
        fields.remove(index);
    }
};

const getFilteredTargets = (targets, selectedTargets, currentIndex) => {
    const unneededTargets = selectedTargets.filter(
        (el, index) => index !== currentIndex
    );
    return targets.filter(
        target =>
            !unneededTargets.some(
                unneed => unneed[FORM_KEYS.TARGETS.VALUE] === target._id
            )
    );
};

const renderSingleTarget = target => {
    return (
        <MenuItem
            key={target._id}
            primaryText={target.title}
            value={target._id}
        />
    );
};

const renderSingleTargetField = (targets = [], onRemove = _.noop) => {
    return (
        <div style={yCenter}>
            <Field
                name={FORM_KEYS.TARGETS.VALUE}
                validate={presence}
                floatingLabelText={'Select account'}
                component={SelectField}
            >
                {targets.map(renderSingleTarget)}
            </Field>
            <IconButton
                style={{ marginLeft: 12, marginTop: 12 }}
                onTouchTap={onRemove}
            >
                <DeleteIcon />
            </IconButton>
        </div>
    );
};

const renderTargetsControl = ({
    fields,
    targets = [],
    selectedTargets = []
}) => {
    if (!fields.length) {
        onTargetAdd(fields)();
    }
    return (
        <div>
            <p>Social media targets</p>
            {fields.map((name, index) => {
                const onRemove = onRemoveTarget(fields, index);
                const filteredTargets = getFilteredTargets(
                    targets,
                    selectedTargets,
                    index
                );
                const targetComponent = renderSingleTargetField(
                    filteredTargets,
                    onRemove
                );
                return (
                    <div key={name} style={yCenter}>
                        <span style={{ marginRight: 12, marginTop: 24 }}>
                            {index + 1}.
                        </span>
                        <FormSection name={name}>
                            {targetComponent}
                        </FormSection>
                    </div>
                );
            })}
            <br />
            <FlatButton
                primary
                label={'Add target'}
                icon={<AddIcon />}
                onTouchTap={onTargetAdd(fields)}
            />
        </div>
    );
};

const TargetsForm = ({ targets = [], selectedTargets = [] }) => {
    return (
        <FieldArray
            name={FORM_KEYS.TARGETS.ARRAY}
            targets={targets}
            selectedTargets={selectedTargets}
            component={renderTargetsControl}
        />
    );
};

export default TargetsForm;



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/components/Form/TargetsForm.js
 **/